module.exports = __webpack_public_path__ + "479364599bec4b445e43501ccbb9d21e.png";